import { OwnersService } from './../../../services/owners.service';
import { Owner } from './../../../models/owner.model';
import { ActivatedRoute } from '@angular/router';
import { UtilsService } from './../../../services/utils.service';
import { ErrorResponse } from './../../../models/error.model';
import { OfficesService } from './../../../services/offices.service';
import { Office } from './../../../models/office.model';
import { Component, OnInit } from '@angular/core';
import { ID } from '../../../models/ID.model';

@Component({
  selector: 'app-owner-details',
  templateUrl: './owner-details.component.html',
  styleUrls: ['./owner-details.component.scss']
})
export class OwnerDetailsComponent implements OnInit {

    owner?: Owner;

    constructor(
        private ownersService: OwnersService,
        private utilsService: UtilsService,
        private route: ActivatedRoute
    ) { }

    ngOnInit(): void {
        this.route.params.subscribe(params => {
            if (params.id) {
                this.getOwner(params.id);
            }
        });
    }

    getOwner(id: ID) {
        this.ownersService.getOwnerById(id).subscribe(owner => {
            this.owner = owner;
        }, (error: ErrorResponse) => this.utilsService.alert('Error al obtener detalles del propietario', error.error?.descripcion));
    }

}
